<template>
  <div class="content">
    <div class="content-box">
      <el-button class="btn" type="danger" @click="to">点击进入股权诊断</el-button>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {}
  },
  mounted() {

  },
  methods:{
    to(){
      this.$router.replace({name:'Information'})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  background: url('/static/image/index.jpg') no-repeat;
  width: 100%;
  height: 100vh;
  background-size: 100% 100%;

}

.content-box {
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100% - 80px);

}


.btn{
  width: 266px;
  height: 60px;
  position: absolute;
  left: 50%;
  top: 55vh;
  transform: translateX(-50%);
  font-size:28px;
}

@media (max-width:768px) {
  .content {
    background: url('/static/image/index.jpg') no-repeat;
    width: 100%;
    height: 100vh;
    background-size: 100% 100%;
  }
}
@media (max-width:480px) {
  .content {
    background: url('/static/image/index.jpg') no-repeat;
    width: 100%;
    height: 100vh;
    background-size: 100% 100%;
  }


}
</style>



// WEBPACK FOOTER //
// src/components/index.vue